import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NAV_LINKS } from '../../../shared/constants/nav-links.constant';
import { NgTextDirective } from '../../../shared/directives/ng-text.directive';
import { NgTextDef } from '../../../shared/enums/text-size.types';
import { NavLink } from '../../../shared/interfaces/nav-links.interface';
import { cn } from '../../../shared/utils/tw-merge';
import { KeyCloakCustomService } from '../../../keycloak/services/key-cloak-custom-service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  imports: [
    RouterModule,
    NzLayoutModule,
    NzMenuModule,
    NzButtonModule,
    NzIconModule,
    NzSpaceModule,
    NgTextDirective,
    NzDropDownModule,
    CommonModule,
  ],
})
export class NavbarComponent implements OnInit {

  uiClass = input<string>('');
  linkClass = input<string>('');
  linkTextKey = input<NgTextDef | null>('div.xl');
  cn = cn;
  isLoggedIn = signal(false);
  keyCloadService = inject(KeyCloakCustomService)
  navLinks = computed<NavLink[]>(() => {
    let data = this.isLoggedIn()
      ? NAV_LINKS
      : NAV_LINKS.filter((link) => link.label !== 'My Account')

    if (!this.keyCloadService.profile()?.isCustomer) {
      data = data.filter((link) => link.label !== 'Booking')
    }
    return data;
  }
  );

  ngOnInit(): void {
    let isLoggedIn = this.keyCloadService.isLoggedIn();
    this.isLoggedIn.set(isLoggedIn);
  }
}
